import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterEventAction } from '../../lib/types/models/center-event-action/center-event-action'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterEventActions(id: number, input: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.centerEvents.getCenterEventActions.url, { id }),
        input
      )
    )
    .get<PaginationResponse<CenterEventAction>>()
}
